import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, from, Observable, of, switchMap, tap } from "rxjs";
import { ButtonType } from "../helpers/button-type.enum";
import { environment } from "src/environments/environment";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class UserPermissionService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  loadCheckPermission(entityType: string | undefined, action: ButtonType): Observable<boolean> {

    return from(this.authService.getRole()).pipe(
      switchMap(role => {

        if (role === 'admin') {
          return of(true);
        }

        // console.log("loadCheckPermission called with:", { entityType, action });

        if (!entityType) {
          //  console.warn("entityType is undefined or empty, returning false");
          return of(false); // Se entityType non è valido, restituisci false
        }

        const url = `${environment.endpointPermission}/${entityType}/${action}`;

        return this.http.get<boolean>(url).pipe(
          tap(response => {
            //  console.log(`Permission response from ${url}:`, response);
          }),
          catchError(error => {
            console.error(`Error fetching permission from ${url}:`, error);
            return of(false); // Se c'è un errore, restituisci false
          })
        );
      })
    );
  }


}
